import { render, staticRenderFns } from "./ImportValidation.vue?vue&type=template&id=512b1bf0&scoped=true"
import script from "./ImportValidation.vue?vue&type=script&lang=js"
export * from "./ImportValidation.vue?vue&type=script&lang=js"
import style0 from "./ImportValidation.vue?vue&type=style&index=0&id=512b1bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512b1bf0",
  null
  
)

export default component.exports